export default __webpack_public_path__ + "static/media/poster-project.615bbf37.png";